<template>
	<div class="table_head">
		<div v-if="upTabType === 'waiting'">
			<p>
				{{ $t("seller.upload.WaitingforReviewTipOne") }}
			</p>
		</div>

		<div v-if="upTabType === 'rejected'">
			<p>{{ $t("seller.upload.RejectedTip") }}</p>
		</div>

		<div class="flex flex_between flex_1" v-if="upTabType!=='waiting'">
			<!--      <uploadBtn v-if="upTabType === 'new'">-->
			<!--        <md-button class="md-blank" v-if="upTabType === 'new'">-->
			<!--          <i class="fa fa-upload" aria-hidden="true"></i>-->
			<!--          {{ $t("seller.upload.missingDocuments") }}-->
			<!--        </md-button>-->
			<!--      </uploadBtn>-->
			<div v-if="upTabType === 'new'">
				<p>{{ $t("seller.upload.newTip") }}</p>
			</div>
			<div v-else></div>

			<el-dropdown @command="(command) => command()">
				<md-button class="md-blank">
					{{ $t("common.allSelected") }}<i class="el-icon-arrow-down el-icon--right"></i>
				</md-button>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item :command="clickEdit">
						<i class="fa fa-fw fa-pencil"></i> {{ $t("common.edit") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickSubmit">
						<i class="fa fa-fw fa-paper-plane"></i> {{ $t("common.button.toReview") }}
					</el-dropdown-item>
					<el-dropdown-item :command="clickDelete" v-if="upTabType === 'new'">
						<i class="fa fa-fw fa-trash-o"></i> {{ $t("common.delete") }}
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>
<script>
import {mapGetters} from "vuex";
import uploadBtn from "@/components/templates/uploadBtn.vue";
import booleanAsIcon from "@/components/templates/agGrid/renderer/BooleanAsIcon.vue";

export default {
	components: {
		uploadBtn
	},
	props: {
		gridApi: Object
	},
	methods: {
		clickItem(type) {
			let checkData = this.gridApi.getSelectedRows();
			if (checkData.length <= 0) {
				this.toast(this.$t("common.warning.needSelectRow"));
				return;
			}
			this.$emit("checHead", {
				checkData: checkData,
				type: type
			});
		},
		checkAnySelectedBelongsToInstallmentContract() {
			return this.gridApi.getSelectedRows().some(row => row.installmentContractId);
		},
		checkAnySelectedIsMissingData() {
			return this.gridApi.getSelectedRows().some(row => !row.invoiceNumber || !row.invoiceDocument);
		},
		getEditError() {
			if (this.checkAnySelectedBelongsToInstallmentContract()) {
				return this.$t("UpLoadTable.error.belongsToInstallmentContract");
			}
			return "";
		},
		getDeleteError() {
			if (this.checkAnySelectedBelongsToInstallmentContract()) {
				return this.$t("UpLoadTable.error.belongsToInstallmentContract");
			}
			return "";
		},
		getSubmitError() {
			if (this.checkAnySelectedBelongsToInstallmentContract()) {
				return this.$t("UpLoadTable.error.belongsToInstallmentContract");
			} else if (this.checkAnySelectedIsMissingData()) {
				return this.$t("UpLoadTable.error.missingData");
			}
			return "";
		},
		clickEdit() {
			const error = this.getEditError();
			if (!error) {
				this.clickItem("edit");
			} else {
				this.toast(error);
			}
		},
		clickDelete() {
			const error = this.getDeleteError();
			if (!error) {
				this.clickItem("del");
			} else {
				this.toast(error);
			}
		},
		clickSubmit() {
			const error = this.getSubmitError();
			if (!error) {
				this.clickItem("share");
			} else {
				this.toast(error);
			}
		},
	},
	computed: {
		...mapGetters({ upTableData: "upTableData", upTabType: "upTabType" })
	}
};
</script>
